import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const CheckboxIcon = (isChecked: boolean) => {
    const IconComponent = (props: SvgIconProps) => (
        <SvgIcon {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <polygon id="Path" points="0 0 24 0 24 24 0 24" />
                    <path
                        d={
                            isChecked
                                ? 'M19,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.11,21 21,20.1 21,19 L21,5 C21,3.9 20.11,3 19,3 Z M10,17 L5,12 L6.41,10.59 L10,14.17 L17.59,6.58 L19,8 L10,17 Z'
                                : 'M19,5 L19,19 L5,19 L5,5 L19,5 Z M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z'
                        }
                        id="Shape"
                        fill="#474747"
                    />
                </g>
            </g>
        </SvgIcon>
    );

    IconComponent.displayName = isChecked
        ? 'CheckboxChecked'
        : 'CheckboxUnchecked';
    return IconComponent;
};

export const CheckboxUnchecked = CheckboxIcon(false);
export const CheckboxChecked = CheckboxIcon(true);
